import { APP_INFO, IS_DEMO } from "../../constants/storageKeys";


export type Platforms = "NETSIS" | "LOGO" | "web";

export function getAppInfo(){

    var info = localStorage.getItem(APP_INFO);
    var appInfo = info ? JSON.parse(info) : {};

    return appInfo;
}
const appHelpers = {

    getTaxNumber() {
   
        var appInfo = getAppInfo();
        var taxNumber = appInfo?.taxNumber != null ? appInfo.taxNumber : appInfo?.tcNumber;

        return taxNumber;
    },
    getNameSurname() {
        const platform = this.getPlatform();
            var appInfo = getAppInfo();
        
        return platform !== "NETSIS" ? appInfo?.userName : appInfo?.userSurName;
    },
    getPlatform():Platforms {
        var info = getAppInfo();
        const platform = process.env.REACT_APP_PLATFORM;
        if (platform == "web") {
            return "web"
        }

        return info?.platform;
    },
    getLicenceKey() {
        var info = getAppInfo();

        var licenceKey = info?.licenceKey;
        if (licenceKey == "085FG7G3K6JC33R8ZJAKBJSB9K" || licenceKey == "06OJZN8NC8MALEPO66ZSC16CCV") {
            licenceKey = "0EC71DC3H5UIVICF6KYKEGDI9J";
        }

        return licenceKey;
    },
    getFirmNumber() {
        var info = getAppInfo();

        return info?.firmNumber;
    },
    getNetsisBranchCode() {
        var info = getAppInfo();

        return info?.companyNr;
    },
    getForCreateFirm() {
        var info = getAppInfo();
        var erpId = 1;
        if (info.platform != "NETSIS") {
            erpId = 2;
        }

        var result = {
            ERPID: erpId,
            FIRMNAME: info.title,
            FIRSHORTNAME: info.FirmShortName,
            USERNAME: info.userName,
            USERSURNAME: info.userSurname,
            TAXCODE: this.getTaxNumber(),
            COUNTRYID: 1,
            EMAIL: info.userEmail,
            PHONE: "",
            ClientId: process.env.REACT_APP_CLIENT_ID,
            ClientSecret: process.env.REACT_APP_CLIENT_SECRET,
            licenceKey: this.getLicenceKey(),

            ADDRESS: info.Address,
            DISTRICT: info.District,
            TAXOFFICE: info.TaxOffice,
            WEB: info.WebAddress,
            FAX: info.Fax,
            CITYID: info.City,
        }


        return result;
    },
    isDemoUser() {
        var info = localStorage.getItem(IS_DEMO)?.toString();

        return info === 'true';
    },
    getLogoAppVersion() { 
        return getAppInfo()?.LogoAppVersion;
    },
    getAppVersion() { 
        return getAppInfo()?.appVersion;
    }
}

export default appHelpers;
